import { useEffect } from "react";
import { MenuItem, SelectChangeEvent } from "@mui/material";
import { useListAdvisorFamilies } from "services/advisor";
import { SxProps } from "@mui/system";
import Select from "../common/Select";

interface Props {
  selectedFamily: string | null;
  onChange: (familyRef: string | null) => void;
  error?: string | null;
  disabled?: boolean;
  sx?: SxProps;
  width?: string;
  size?: "small" | "medium";
}

export default ({
  selectedFamily,
  onChange,
  error,
  disabled,
  sx,
  width = "100%",
  size = "small",
}: Props) => {
  const { data, request } = useListAdvisorFamilies();
  useEffect(() => {
    request();
  }, []);
  const handleChange = (event: SelectChangeEvent) => {
    const selectedValue = event.target.value;
    onChange(selectedValue || null);
  };

  const families = data?.families || [];
  const sortedFamilies = families.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Select
      variant="detachedOutlined"
      placeholder="Select Family"
      size={size}
      disabled={disabled}
      error={!!error}
      value={(!!families.length && selectedFamily) || ""}
      onChange={handleChange}
      displayEmpty
      sx={{
        width: width,
        "& .MuiInputBase-input": {
          color: !selectedFamily ? "#8E9598" : "inherit",
        },
        ...sx,
      }}
    >
      <MenuItem value="" disabled>
        Select Family
      </MenuItem>
      {sortedFamilies.map((family) => (
        <MenuItem key={family.ref} value={family.ref}>
          {family.name}
        </MenuItem>
      ))}
    </Select>
  );
};
